module.exports = __webpack_public_path__ + "static/media/951e7802-0433-4924-868c-71204174c6d5.3c628506.jpg";